/* Presentation only for the ordinary Shopify Forms popup. No signup or storage writes. */
(() => {
  'use strict';
  const hostId = 'app-embed-container-911995';
  const styleId = 'guya-newsletter-fit';
  const css = `
    #app-embed { box-sizing: border-box !important; }
    #app-embed:not([data-current-step="tease"]) {
      inset: 0 !important; width: 100% !important; height: 100% !important;
      padding: 0 !important; transform: none !important; rotate: none !important;
    }
    #app-embed section[role="dialog"]:not([data-sizing]) {
      top: var(--guya-nl-top, 0px) !important;
      left: var(--guya-nl-left, 0px) !important;
      width: var(--guya-nl-width, 100vw) !important;
      height: var(--guya-nl-height, 100dvh) !important;
      padding: max(12px, env(safe-area-inset-top)) max(12px, env(safe-area-inset-right)) max(12px, env(safe-area-inset-bottom)) max(12px, env(safe-area-inset-left));
      box-sizing: border-box !important;
    }
    #app-embed section[data-sizing="form-wrapper"][role="dialog"] {
      position: relative !important; box-sizing: border-box !important;
      width: min(760px, calc(var(--guya-nl-width, 100vw) - 24px)) !important;
      min-width: 0 !important; max-width: 760px !important;
      max-height: calc(var(--guya-nl-height, 100dvh) - 24px - env(safe-area-inset-top) - env(safe-area-inset-bottom)) !important;
      overflow: hidden !important;
      grid-template-columns: minmax(0, 0.8fr) minmax(0, 1fr) !important;
      grid-template-rows: minmax(0, 1fr) !important;
      border-radius: 12px !important;
    }
    #app-embed [class*="_gridItem_"][style*="background-image"] {
      min-height: 0 !important; background-size: contain !important;
      background-position: center !important; background-color: #edf2e9;
    }
    #app-embed [class*="_gridItemContent_"] {
      box-sizing: border-box; min-width: 0; min-height: 0;
      overflow-y: auto !important; overscroll-behavior: contain;
      -webkit-overflow-scrolling: touch;
      padding: 52px 24px 20px !important;
      scrollbar-gutter: stable;
    }
    #app-embed [class*="_formHeader_"] { margin: 0 0 16px !important; }
    #app-embed h2 { font-size: 22px !important; line-height: 1.2 !important; margin: 0 0 10px !important; overflow-wrap: anywhere; }
    #app-embed [class*="_textBody_"] { font-size: 16px !important; line-height: 1.4 !important; }
    #app-embed [class*="_textBody_"] p { margin: 0 !important; }
    #app-embed form { gap: 12px !important; }
    #app-embed input { box-sizing: border-box !important; font-size: 16px !important; min-height: 48px; }
    #app-embed [data-testid="btn-form-submit"] { box-sizing: border-box !important; font-size: 16px !important; min-height: 48px; padding: 12px 16px !important; }
    #app-embed [class*="_formDisclaimer_"] { font-size: 12px !important; line-height: 1.4 !important; padding: 0 !important; margin-top: 12px !important; }
    #app-embed [class*="_formContainerCloseButtonPosition_"] {
      position: absolute !important; top: 6px !important; right: 6px !important;
      z-index: 5 !important;
    }
    #app-embed [aria-label="Close modal"] {
      display: inline-flex !important; align-items: center; justify-content: center;
      box-sizing: border-box; flex: 0 0 44px;
      width: 44px !important; height: 44px !important; min-width: 44px;
      padding: 0 !important; background: #fff !important; color: #163b2a;
      border: 1px solid #d3dcd6 !important; border-radius: 50% !important;
      touch-action: manipulation; cursor: pointer;
    }
    #app-embed [aria-label="Close modal"] svg { width: 18px; height: 18px; fill: currentColor; fill-opacity: 1; }
    #app-embed [aria-label="Close modal"]:focus-visible { outline: 3px solid #1878b9; outline-offset: 2px; }
    @media (max-width: 768px) {
      #app-embed section[data-sizing="form-wrapper"][role="dialog"] {
        width: min(400px, calc(var(--guya-nl-width, 100vw) - 24px)) !important;
        grid-template-columns: minmax(0, 1fr) !important;
        grid-template-rows: clamp(80px, 16vh, 112px) minmax(0, 1fr) !important;
        grid-template-areas: 'image' 'content' !important;
      }
      #app-embed [class*="_gridItem_"][style*="background-image"] {
        background-size: cover !important; background-position: center 38% !important;
        border-radius: 12px 12px 0 0 !important;
      }
      #app-embed [class*="_gridItemContent_"] { padding: 18px 20px 18px !important; }
      #app-embed[data-current-step="tease"] {
        position: fixed !important; inset: auto 12px max(16px, env(safe-area-inset-bottom)) auto !important;
        width: auto !important; height: auto !important; padding: 0 !important;
        transform: none !important; rotate: none !important;
      }
      #app-embed [data-testid="form-teaser"] {
        margin: 0 !important; padding: 3px 3px 3px 12px !important;
        gap: 6px !important; max-width: calc(100vw - 132px) !important;
        min-height: 50px; border-radius: 12px !important;
      }
      #app-embed [data-testid="form-teaser"] h3 { font-size: 14px !important; line-height: 18px !important; }
      #app-embed [data-testid="form-teaser"] [aria-label="Close modal"] { border-radius: 9px !important; background: #f3f6f3 !important; }
    }
    @media (max-height: 500px) {
      #app-embed section[data-sizing="form-wrapper"][role="dialog"] {
        grid-template-columns: minmax(0, 1fr) !important;
        grid-template-rows: minmax(0, 1fr) !important;
        grid-template-areas: 'content' !important;
      }
      #app-embed [class*="_gridItem_"][style*="background-image"] { display: none !important; }
      #app-embed [class*="_gridItemContent_"] { padding-top: 52px !important; }
    }
  `;
  let attachedHost;
  let frame = 0;
  function updateViewport() {
    frame = 0;
    if (!attachedHost?.isConnected) return;
    const viewport = window.visualViewport;
    const values = {
      height: viewport?.height || window.innerHeight,
      width: viewport?.width || document.documentElement.clientWidth,
      top: viewport?.offsetTop || 0,
      left: viewport?.offsetLeft || 0
    };
    for (const [key, value] of Object.entries(values)) {
      attachedHost.style.setProperty('--guya-nl-' + key, value + 'px');
    }
  }
  function queueViewport() {
    if (!frame) frame = requestAnimationFrame(updateViewport);
  }
  function attach() {
    const host = document.getElementById(hostId);
    if (!host || host.localName !== 'shopify-forms-embed' || !host.shadowRoot) return;
    attachedHost = host;
    if (!host.shadowRoot.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = css;
      host.shadowRoot.append(style);
      // Shopify uses a focusable span for close; complete its Space-key behavior.
      host.shadowRoot.addEventListener('keydown', (event) => {
        const close = event.target.closest?.('[aria-label="Close modal"]');
        if (event.key === ' ' && close) {
          event.preventDefault(); event.stopPropagation(); close.click();
        }
      });
    }
    queueViewport();
  }
  new MutationObserver(attach).observe(document.body, { childList: true });
  window.addEventListener('resize', queueViewport, { passive: true });
  window.visualViewport?.addEventListener('resize', queueViewport, { passive: true });
  window.visualViewport?.addEventListener('scroll', queueViewport, { passive: true });
  attach();
})();
